<template>
  <div>
    <v-container>
      <v-card flat outlined class="pb-6">
        <v-card-title primary-title>
          <v-icon class="mr-2">mdi-account</v-icon>
          Profil
        </v-card-title>
        <v-row>
          <v-col cols="4">
            <v-card flat outlined class="ml-4 pa-4 fill-height">
              <v-img
                class="rounded-circle mx-auto"
                src="https://randomuser.me/api/portraits/men/85.jpg"
                max-height="200"
                max-width="200"
                contain
                @click="zoom('https://randomuser.me/api/portraits/men/85.jpg')"
              ></v-img>
              <!-- DIALOG GANTI FOTO PROFIL -->
              <v-dialog v-model="fotoProfilDialog" max-width="300">
                <template v-slot:activator="{ on, attrs }">
                  <div class="text-center mt-2">
                    <v-btn v-bind="attrs" v-on="on" color="primary">
                      Ganti Foto
                    </v-btn>
                  </div>
                </template>

                <v-card>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn icon @click="fotoProfilDialog = false">
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </v-card-actions>
                  <v-card-text>
                    <v-file-input
                      accept="image/*"
                      prepend-icon="mdi-camera"
                      label="Pilih Gambar"
                      truncate-length="15"
                    ></v-file-input>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @click="fotoProfilDialog = false" color="primary">
                      simpan
                    </v-btn>
                    <v-spacer></v-spacer>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-card>
          </v-col>
          <v-col cols="8">
            <v-card flat outlined class="mr-4">
              <v-toolbar flat color="primary white--text">
                <v-toolbar-title>{{
                  this.$store.getters.getUser
                }}</v-toolbar-title>
              </v-toolbar>
              <v-card-text>
                <ul>
                  <li>Nama: {{ this.full_name }}</li>
                  <li>Email: {{ this.email }}</li>
                </ul>
              </v-card-text>
            </v-card>
            <v-btn color="primary" class="mt-3" to="/admin/profileUpdate"
              >Update Profil</v-btn
            >
          </v-col>
        </v-row>
      </v-card>
    </v-container>

    <!-- DETAIL MASJID -->
    <v-container>
      <v-card flat outlined class="pb-6">
        <v-card-title primary-title>
          <v-icon class="mr-2">mdi-account</v-icon>
          Detail Masjid
        </v-card-title>
        <v-row>
          <v-col cols="4">
            <v-card flat outlined class="ml-4 pa-4 fill-height">
              <v-img
                v-if="masjidDetail == undefined || !this.isImages"
                class="mx-4"
                contain
                :src="require('../../assets/mosque-noimage.png')"
                height="200px"
              >
                <template v-slot:placeholder>
                  <v-row
                    class="fill-height ma-0"
                    align="center"
                    justify="center"
                  >
                    <v-progress-circular
                      indeterminate
                      color="grey"
                    ></v-progress-circular>
                  </v-row>
                </template>
              </v-img>
              <v-container v-if="masjidDetail != undefined">
                <v-carousel
                  v-if="masjidDetail.images && masjidDetail.images.length"
                  cycle
                  interval="4000"
                  hide-delimiters
                  :show-arrows="true"
                  height="200px"
                >
                  <v-carousel-item
                    v-for="(img, i) in masjidDetail.images"
                    :key="i"
                    class="white--text align-end"
                    :src="img.url"
                    contain
                    @click="zoom(img.url)"
                  >
                    <template v-slot:placeholder>
                      <v-row
                        class="fill-height ma-0"
                        align="center"
                        justify="center"
                      >
                        <v-progress-circular
                          indeterminate
                          color="grey"
                        ></v-progress-circular>
                      </v-row>
                    </template>
                  </v-carousel-item>
                </v-carousel>
                <!-- GALERI DIALOG -->
                <v-dialog
                  v-model="galeriDialog"
                  fullscreen
                  hide-overlay
                  transition="dialog-bottom-transition"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <div class="text-center mt-2 text-subtitle-1">
                      <v-btn color="primary" v-bind="attrs" v-on="on" dark
                        >Galeri Masjid</v-btn
                      >
                    </div>
                  </template>

                  <v-card>
                    <v-toolbar dark color="primary">
                      <v-btn icon dark @click="galeriDialog = false">
                        <v-icon>mdi-close</v-icon>
                      </v-btn>
                      <v-toolbar-title>Galeri Masjid</v-toolbar-title>
                      <v-spacer></v-spacer>
                      <v-toolbar-items>
                        <!-- DIALOG INPUT FOTO -->
                        <v-dialog v-model="fotoMasjidDialog" max-width="300">
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn text dark v-on="on" v-bind="attrs">
                              tambah gambar
                            </v-btn>
                          </template>

                          <v-card>
                            <v-card-actions>
                              <v-spacer></v-spacer>
                              <v-btn icon @click="fotoMasjidDialog = false">
                                <v-icon>mdi-close</v-icon>
                              </v-btn>
                            </v-card-actions>
                            <v-card-text>
                              <v-file-input
                                v-model="file"
                                accept="image/*"
                                prepend-icon="mdi-camera"
                                label="Pilih Gambar"
                              >
                              </v-file-input>
                            </v-card-text>
                            <v-card-actions>
                              <v-spacer></v-spacer>
                              <v-btn @click="addImage" color="primary">
                                simpan
                                <v-progress-circular
                                  v-if="isSubmitLoading == true"
                                  class="ml-2"
                                  indeterminate
                                  color="secondary"
                                  size="16"
                                  width="2"
                                ></v-progress-circular>
                              </v-btn>
                              <v-spacer></v-spacer>
                            </v-card-actions>
                          </v-card>
                        </v-dialog>
                      </v-toolbar-items>
                    </v-toolbar>

                    <v-alert v-model="successAlert" dismissible type="success"
                      >Berhasil menambahkan gambar</v-alert
                    >
                    <v-alert v-model="errorAlert" dismissible type="error"
                      >Gagal menambahkan gambar</v-alert
                    >

                    <!-- IMAGES GENERATOR -->
                    <v-container fluid class="d-flex flex-wrap">
                      <v-card
                        v-for="(img, i) in masjidDetail.images.slice().reverse()"
                        :key="i"
                        outlined
                        tile
                        elevation="2"
                        class="ma-2"
                        max-width="320px"
                        style="position: relative"
                      >
                        <div style="position: absolute; right: 5px; top: 5px; z-index: 1">
                          <v-btn small elevation="1" color="white" fab>
                            <v-icon color="primary" >mdi-delete</v-icon>
                          </v-btn>
                        </div>
                        <v-img
                          :src="img.url"
                          height="300"
                          width="300"
                          class="mx-auto mt-2 mb-2"
                          contain
                        />
                      </v-card>
                    </v-container>
                  </v-card>
                </v-dialog>

                <v-dialog v-model="dialog" max-width="500">
                  <v-card>
                    <v-img :src="selectedImage" />

                    <v-divider></v-divider>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="primary" text @click="dialog = false"
                        >Close</v-btn
                      >
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-container>
            </v-card>
          </v-col>
          <v-col cols="8">
            <v-card flat outlined class="mr-4 mb-3" v-if="idMasjid != 'null'">
              <v-toolbar flat color="primary white--text">
                <v-toolbar-title>{{ this.masjidDetail.name }}</v-toolbar-title>
              </v-toolbar>
              <v-card-text>
                <ul>
                  <li>Alamat: {{ this.masjidDetail.address }}</li>
                  <li>Kota: {{ this.masjidDetail.city }}</li>
                  <li>Provinsi: {{ this.masjidDetail.province }}</li>
                  <li>Tahun dibangun: {{ this.masjidDetail.year_built }}</li>
                  <li>Info lainnya: {{ this.masjidDetail.additional_info }}</li>
                </ul>
              </v-card-text>
            </v-card>

            <v-btn
              color="primary"
              v-if="this.idMasjid == 'null'"
              elevation="2"
              to="/admin/masjid"
              >Daftarkan Masjid</v-btn
            >

            <v-btn
              color="primary"
              v-else
              class="mt-3"
              elevation="2"
              to="/admin/update"
              >Update Data Masjid</v-btn
            >
          </v-col>
        </v-row>
      </v-card>
    </v-container>
  </div>
</template>
<script>
export default {
  data() {
    return {
      fotoMasjidDialog: false,
      fotoProfilDialog: false,
      errorAlert: false,
      successAlert: false,
      isSubmitLoading: false,
      file: null,
      galeriDialog: false,
      selectedImage: null,
      dialog: false,
      masjidDetail: {},
      full_name: "",
      email: "",
      username: "",
      idMasjid: localStorage.getItem("masjid"),
      isImages: false,
    };
  },
  created() {
    var masjidId = localStorage.getItem("masjid");
    var token = this.$store.getters.getToken;

    //fetch user detail
    this.axios({
      url: "/meta_",
      method: "get",
      header: token,
    })
      .then((response) => {
        this.full_name = response.data.full_name;
        this.email = response.data.email;
        this.username = response.data.username;
        let id = response.data.masjid.masjid_uid;
        if (masjidId == "null" || masjidId == "") {
          localStorage.removeItem("masjid");
          localStorage.setItem("masjid", id);
          masjidId = id;
        }

        //fetch masjid detail
        return this.axios("masjid/detail/" + masjidId);
      })
      .then((response) => {
        if (response.data.data !== null) {
          this.masjidDetail = response.data.data;
          // console.log(this.masjidDetail, 'masjid detail')

          if (this.masjidDetail.images) {
            if (this.masjidDetail.images.length != 0) this.isImages = true;
          }
        }
      })
      .catch((error) => {
        console.log(error, "error fetch user details");
      });
  },
  methods: {
    zoom(url) {
      console.log(url, "zoom");
      this.selectedImage = url;
      this.dialog = true;
    },
    async addImage() {
      this.isSubmitLoading = true;
      if (this.file !== null) {
        let masjidId = localStorage.getItem("masjid");
        let formData = new FormData();
        formData.append("file", this.file);
        // console.log(formData)
        //add file images
        await this.axios
          .post(`/masjid/image/${masjidId}`, formData, {
            headers: { "Content-Type": "multipart/form-data" },
          })
          .then((response) => {
            console.log(response, "res update masjid images");
            this.file = null;
          })
          .catch((error) => {
            console.log(error, "error update masjid images");
            this.errorAlert = true;
          });

        this.axios("masjid/detail/" + masjidId)
          .then((response) => {
            if (response.data.data !== null) {
              this.masjidDetail = response.data.data;
              // console.log(this.masjidDetail, 'masjid detail')

              if (this.masjidDetail.images) {
                if (this.masjidDetail.images.length != 0) this.isImages = true;
              }
            }
            this.isSubmitLoading = false;
            this.successAlert = true;
          })
          .catch((error) => {
            console.log(error, "error fetch masjid details");
            this.isSubmitLoading = false;
            this.errorAlert = true;
          });
        this.fotoMasjidDialog = false;
      } else {
        this.errorAlert = true;
        this.isSubmitLoading = false;
        this.fotoMasjidDialog = false;
      }
    },
  },
};
</script>
